module.exports = __webpack_public_path__ + "img/2.2c92cab7.png";